import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { identityBaseUrl, siteDomain } from '@trello/config';

interface SwitchAccountsLinkProps {
  returnUrl: string;
}

export const SwitchAccountsLink: FunctionComponent<SwitchAccountsLinkProps> = ({
  returnUrl,
}) => {
  return (
    <a
      href={`${identityBaseUrl}/login?${new URLSearchParams({
        prompt: 'select_account',
        continue: `${siteDomain}/auth/atlassian/callback?returnUrl=${returnUrl}`,
        application: 'trello',
      }).toString()}`}
    >
      <FormattedMessage
        id="templates.invitation_link.switch-accounts"
        defaultMessage="Switch accounts"
        description="Text for switching accounts"
      />
    </a>
  );
};
